module.exports = __webpack_public_path__ + "img/formador-15.958b1979.png";